export default __webpack_public_path__ + "static/media/1622445.91757f08.jpg";